import React from 'react';

const OrderDetails = ({ order, onClose }) => {
  if (!order) return null;

  // Static location data for demo
  const staticLocations = {
    user: { lat: 17.3850, lng: 78.4867, address: "Hitech City, Hyderabad, Telangana - 500081" },
    restaurant: { lat: 17.4075, lng: 78.4756, address: "Madhapur, Hyderabad, Telangana - 500081" },
    rider: { lat: 17.3965, lng: 78.4812, address: "Jubilee Hills, Hyderabad, Telangana - 500033" }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const d = new Date(dateString);
    return d.toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusBadge = (status) => {
    const styles = {
      Completed: { background: '#c6f6d5', color: '#276749' },
      Delivered: { background: '#c6f6d5', color: '#276749' },
      Pending: { background: '#fefcbf', color: '#975a16' },
      Processing: { background: '#fefcbf', color: '#975a16' },
      Cancelled: { background: '#fed7d7', color: '#9b2c2c' },
      Canceled: { background: '#fed7d7', color: '#9b2c2c' }
    };
    const style = styles[status] || { background: '#e2e8f0', color: '#4a5568' };
    return (
      <span style={{
        display: 'inline-block',
        padding: '4px 14px',
        borderRadius: '20px',
        fontSize: '12px',
        fontWeight: '600',
        ...style
      }}>
        {status}
      </span>
    );
  };

  return (
    <>
      {/* Overlay */}
      <div
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(0, 0, 0, 0.6)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 10000,
          padding: '20px',
          animation: 'fadeIn 0.3s ease'
        }}
        onClick={onClose}
      >
        {/* Modal */}
        <div
          style={{
            background: '#fff',
            borderRadius: '16px',
            maxWidth: '900px',
            width: '100%',
            maxHeight: '90vh',
            overflowY: 'auto',
            boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
            animation: 'slideUp 0.3s ease',
            padding: '0'
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '20px 24px',
            borderBottom: '2px solid #f0f0f0',
            position: 'sticky',
            top: 0,
            background: '#fff',
            zIndex: 10,
            borderTopLeftRadius: '16px',
            borderTopRightRadius: '16px'
          }}>
            <div>
              <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#2d3748' }}>
                Order Details
              </h2>
              <span style={{ fontSize: '13px', color: '#718096' }}>
                Order ID: #{order.orderId}
              </span>
            </div>
            <button
              onClick={onClose}
              style={{
                border: 'none',
                background: '#f5f5f5',
                borderRadius: '50%',
                width: '36px',
                height: '36px',
                fontSize: '18px',
                cursor: 'pointer',
                color: '#666',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = '#e0e0e0'}
              onMouseLeave={(e) => e.currentTarget.style.background = '#f5f5f5'}
            >
              ✕
            </button>
          </div>

          {/* Body */}
          <div style={{ padding: '24px' }}>

            {/* Order Summary Card */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
              gap: '16px',
              background: '#f8fafc',
              padding: '16px 20px',
              borderRadius: '12px',
              marginBottom: '24px'
            }}>
              <div>
                <span style={{ fontSize: '12px', color: '#718096' }}>Order Date</span>
                <div style={{ fontWeight: '600', fontSize: '14px' }}>{formatDate(order.orderDateAndTime)}</div>
              </div>
              <div>
                <span style={{ fontSize: '12px', color: '#718096' }}>Amount</span>
                <div style={{ fontWeight: '600', fontSize: '18px', color: '#0b5e42' }}>
                  ₹{Math.round(order.grandTotal) || 0}
                </div>
              </div>
              <div>
                <span style={{ fontSize: '12px', color: '#718096' }}>Payment Method</span>
                <div style={{ fontWeight: '500', fontSize: '14px' }}>
                  {order.paymentMethod?.replace(/[_-]/g, "") || "-"}
                </div>
              </div>
              <div>
                <span style={{ fontSize: '12px', color: '#718096' }}>Status</span>
                <div>{getStatusBadge(order.status)}</div>
              </div>
            </div>

            {/* Three Column Layout */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr',
              gap: '20px',
              marginBottom: '24px'
            }}>
              {/* User Details */}
              <div style={{
                border: '1px solid #e2e8f0',
                borderRadius: '12px',
                padding: '16px',
                background: '#fff'
              }}>
                <h4 style={{ margin: '0 0 12px 0', fontSize: '14px', color: '#4a5568' }}>
                  👤 User Details
                </h4>
                <div style={{ fontSize: '13px', lineHeight: '1.8' }}>
                  <div><strong>Name:</strong> {order.userName || "-"}</div>
                  <div><strong>Company:</strong> {order.userCompany || "-"}</div>
                  <div><strong>Phone:</strong> {order.userPhone || "-"}</div>
                  <div><strong>Email:</strong> {order.userEmail || "-"}</div>
                  <div><strong>Order Type:</strong> {order.orderType?.replace(/[_-]/g, "") || "-"}</div>
                </div>
              </div>

              {/* Restaurant Details */}
              <div style={{
                border: '1px solid #e2e8f0',
                borderRadius: '12px',
                padding: '16px',
                background: '#fff'
              }}>
                <h4 style={{ margin: '0 0 12px 0', fontSize: '14px', color: '#4a5568' }}>
                  🏪 Restaurant Details
                </h4>
                <div style={{ fontSize: '13px', lineHeight: '1.8' }}>
                  <div><strong>Vendor ID:</strong> {order.vendorId || "-"}</div>
                  <div><strong>Restaurant:</strong> {order.restaurantName || "-"}</div>
                  <div><strong>Category:</strong> {order.appType || "Food"}</div>
                  <div><strong>Phone:</strong> {order.vendorPhone || "-"}</div>
                  <div><strong>Address:</strong> {order.vendorAddress || "Madhapur, Hyderabad"}</div>
                </div>
              </div>

              {/* Rider Details */}
              <div style={{
                border: '1px solid #e2e8f0',
                borderRadius: '12px',
                padding: '16px',
                background: '#fff'
              }}>
                <h4 style={{ margin: '0 0 12px 0', fontSize: '14px', color: '#4a5568' }}>
                  🛵 Rider Details
                </h4>
                <div style={{ fontSize: '13px', lineHeight: '1.8' }}>
                  {order.riderName ? (
                    <>
                      <div><strong>Name:</strong> {order.riderName}</div>
                      <div><strong>Phone:</strong> {order.riderPhone || "+91 98765 43210"}</div>
                      <div><strong>Vehicle:</strong> {order.riderVehicle || "Bike - KA 01 AB 1234"}</div>
                      <div><strong>Status:</strong> <span style={{ color: '#48bb78' }}>● Active</span></div>
                    </>
                  ) : (
                    <div style={{ color: '#a0aec0', textAlign: 'center', padding: '20px 0' }}>
                      <div style={{ fontSize: '32px' }}>🚫</div>
                      <div style={{ marginTop: '8px', fontSize: '13px' }}>No rider assigned yet</div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Location Map Section */}
            <div style={{
              border: '1px solid #e2e8f0',
              borderRadius: '12px',
              padding: '16px',
              background: '#fff'
            }}>
              <h4 style={{ margin: '0 0 16px 0', fontSize: '14px', color: '#4a5568' }}>
                📍 Location Details
              </h4>

              {/* Static Map Placeholder */}
              <div style={{
                background: '#eef2f7',
                borderRadius: '10px',
                height: '220px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                overflow: 'hidden',
                marginBottom: '16px'
              }}>
                {/* Map Placeholder with Pins */}
                <div style={{
                  position: 'relative',
                  width: '100%',
                  height: '100%',
                  background: 'linear-gradient(135deg, #e8ecf1 0%, #d5dce4 100%)'
                }}>
                  {/* Grid lines for map feel */}
                  <div style={{
                    position: 'absolute',
                    inset: 0,
                    backgroundImage: 'radial-gradient(circle, #b0bec5 1px, transparent 1px)',
                    backgroundSize: '30px 30px',
                    opacity: 0.3
                  }} />

                  {/* User Pin (Blue) */}
                  <div style={{
                    position: 'absolute',
                    bottom: '40%',
                    left: '25%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                  }}>
                    <div style={{
                      width: '24px',
                      height: '24px',
                      borderRadius: '50%',
                      background: '#2563eb',
                      border: '3px solid white',
                      boxShadow: '0 2px 8px rgba(37,99,235,0.4)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontSize: '12px',
                      fontWeight: 'bold'
                    }}>U</div>
                    <span style={{
                      fontSize: '10px',
                      background: 'rgba(37,99,235,0.9)',
                      color: 'white',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      marginTop: '4px',
                      fontWeight: '500'
                    }}>User</span>
                    <span style={{
                      fontSize: '9px',
                      color: '#4a5568',
                      marginTop: '2px',
                      maxWidth: '120px',
                      textAlign: 'center'
                    }}>{staticLocations.user.address.split(',')[0]}</span>
                  </div>

                  {/* Restaurant Pin (Orange) */}
                  <div style={{
                    position: 'absolute',
                    bottom: '55%',
                    right: '28%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                  }}>
                    <div style={{
                      width: '24px',
                      height: '24px',
                      borderRadius: '50%',
                      background: '#e65d2e',
                      border: '3px solid white',
                      boxShadow: '0 2px 8px rgba(230,93,46,0.4)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontSize: '12px',
                      fontWeight: 'bold'
                    }}>R</div>
                    <span style={{
                      fontSize: '10px',
                      background: 'rgba(230,93,46,0.9)',
                      color: 'white',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      marginTop: '4px',
                      fontWeight: '500'
                    }}>Restaurant</span>
                    <span style={{
                      fontSize: '9px',
                      color: '#4a5568',
                      marginTop: '2px',
                      maxWidth: '120px',
                      textAlign: 'center'
                    }}>{staticLocations.restaurant.address.split(',')[0]}</span>
                  </div>

                  {/* Rider Pin (Green) - Only if rider assigned */}
                  {order.riderName && (
                    <div style={{
                      position: 'absolute',
                      bottom: '65%',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center'
                    }}>
                      <div style={{
                        width: '24px',
                        height: '24px',
                        borderRadius: '50%',
                        background: '#22c55e',
                        border: '3px solid white',
                        boxShadow: '0 2px 8px rgba(34,197,94,0.4)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        animation: 'pulse 1.5s ease-in-out infinite'
                      }}>D</div>
                      <span style={{
                        fontSize: '10px',
                        background: 'rgba(34,197,94,0.9)',
                        color: 'white',
                        padding: '2px 8px',
                        borderRadius: '4px',
                        marginTop: '4px',
                        fontWeight: '500'
                      }}>Rider</span>
                      <span style={{
                        fontSize: '9px',
                        color: '#4a5568',
                        marginTop: '2px',
                        maxWidth: '120px',
                        textAlign: 'center'
                      }}>{staticLocations.rider.address.split(',')[0]}</span>
                    </div>
                  )}

                  {/* Connecting Line (User to Restaurant) */}
                  <svg style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    pointerEvents: 'none'
                  }}>
                    <line
                      x1="30%"
                      y1="58%"
                      x2="70%"
                      y2="45%"
                      stroke="#2563eb"
                      strokeWidth="2"
                      strokeDasharray="6,4"
                      opacity="0.5"
                    />
                    {order.riderName && (
                      <line
                        x1="50%"
                        y1="30%"
                        x2="30%"
                        y2="58%"
                        stroke="#22c55e"
                        strokeWidth="2"
                        strokeDasharray="6,4"
                        opacity="0.5"
                      />
                    )}
                  </svg>

                  {/* Legend */}
                  <div style={{
                    position: 'absolute',
                    bottom: '10px',
                    right: '12px',
                    background: 'rgba(255,255,255,0.9)',
                    padding: '6px 12px',
                    borderRadius: '8px',
                    fontSize: '10px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '2px'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <span style={{ color: '#2563eb', fontWeight: 'bold' }}>●</span> User
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <span style={{ color: '#e65d2e', fontWeight: 'bold' }}>●</span> Restaurant
                    </div>
                    {order.riderName && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <span style={{ color: '#22c55e', fontWeight: 'bold' }}>●</span> Rider
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Addresses */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: order.riderName ? '1fr 1fr 1fr' : '1fr 1fr',
                gap: '12px',
                fontSize: '12px',
                color: '#4a5568'
              }}>
                <div>
                  <strong>User Address:</strong><br />
                  {staticLocations.user.address}
                </div>
                <div>
                  <strong>Restaurant Address:</strong><br />
                  {staticLocations.restaurant.address}
                </div>
                {order.riderName && (
                  <div>
                    <strong>Rider Address:</strong><br />
                    {staticLocations.rider.address}
                  </div>
                )}
              </div>
            </div>

            {/* Order Items (if available) */}
            {order.items && order.items.length > 0 && (
              <div style={{
                border: '1px solid #e2e8f0',
                borderRadius: '12px',
                padding: '16px',
                background: '#fff',
                marginTop: '16px'
              }}>
                <h4 style={{ margin: '0 0 12px 0', fontSize: '14px', color: '#4a5568' }}>
                  🍽️ Order Items
                </h4>
                <div style={{ fontSize: '13px' }}>
                  {order.items.map((item, idx) => (
                    <div key={idx} style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      padding: '6px 0',
                      borderBottom: idx < order.items.length - 1 ? '1px solid #f0f0f0' : 'none'
                    }}>
                      <span>{item.name || `Item ${idx + 1}`}</span>
                      <span style={{ fontWeight: '500' }}>₹{item.price || 0}</span>
                    </div>
                  ))}
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    paddingTop: '8px',
                    borderTop: '2px solid #e2e8f0',
                    fontWeight: '600',
                    marginTop: '4px'
                  }}>
                    <span>Total</span>
                    <span>₹{Math.round(order.grandTotal) || 0}</span>
                  </div>
                </div>
              </div>
            )}

            {/* Feedback Section */}
            {order.feedback && (
              <div style={{
                border: '1px solid #e2e8f0',
                borderRadius: '12px',
                padding: '16px',
                background: '#fff',
                marginTop: '16px'
              }}>
                <h4 style={{ margin: '0 0 8px 0', fontSize: '14px', color: '#4a5568' }}>
                  💬 Feedback
                </h4>
                <div style={{ fontSize: '13px', color: '#4a5568' }}>
                  <div><strong>Rating:</strong> {order.ratings || "-"} ⭐</div>
                  <div style={{ marginTop: '4px' }}><strong>Comment:</strong> {order.feedback}</div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Global Styles for Animations */}
      <style dangerouslySetInnerHTML={{
        __html: `
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          @keyframes slideUp {
            from {
              opacity: 0;
              transform: translateY(30px) scale(0.95);
            }
            to {
              opacity: 1;
              transform: translateY(0) scale(1);
            }
          }
          @keyframes pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.1); }
          }
        `
      }} />
    </>
  );
};

export default OrderDetails;